

















































































































































































































































































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import {
  DrivewealthAccountSummary,
  DrivewealthAccountManagementType,
  DrivewealthAccountLiquidationStatus,
  DrivewealthWizardStep,
} from "@/shared/types";
import { Location } from "vue-router";
import { formatCurrency } from "@/shared/currency";
import _ from "lodash";
import moment from "moment-timezone";
import * as SharedRoutes from "@/shared/route-names";
import * as RouteNames from "@/employee/route-names";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import InvestmentAccountTypeFeeDetails from "@/shared/components/investments/drivewealth/InvestmentAccountTypeFeeDetails.vue";
import InvestmentFeeDisclaimer from "@/employee/components/investments/drivewealth/InvestmentFeeDisclaimer.vue";
import AccountTypeSubheader from "@/employee/components/investments/drivewealth/AccountTypeSubheader.vue";
import HsabInvestmentAccountRedirectLink from "@/shared/components/investments/HsabInvestmentAccountRedirectLink.vue";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useEnrollmentStore } from "@/employee/store/enrollment";
import { useInvestmentThresholdStore } from "@/shared/store/investmentThreshold";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useInvestmentDailyBalanceStore } from "@/shared/store/investmentDailyBalance";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";

@Component({
  components: {
    GenericLoadingSpinner,
    InvestmentAccountTypeFeeDetails,
    InvestmentFeeDisclaimer,
    AccountTypeSubheader,
    HsabInvestmentAccountRedirectLink
  }
})
export default class MultipleAccountSelection extends Vue {
  drivewealthStore = useDrivewealthStore();
  enrollmentStore = useEnrollmentStore();
  investmentThresholdStore = useInvestmentThresholdStore();
  custodianSettingsStore = useCustodianSettingsStore();
  investmentDailyBalanceStore = useInvestmentDailyBalanceStore();
  featureFlagStore = useFeatureFlagStore();

  SharedRoutes = SharedRoutes;
  RouteNames = RouteNames;
  formatCurrency = formatCurrency;

  DrivewealthAccountManagementType = DrivewealthAccountManagementType;
  DrivewealthAccountLiquidationStatus = DrivewealthAccountLiquidationStatus;

  mounted (): void {
    this.enrollmentStore.loadFees();
    this.investmentThresholdStore.loadInvestmentThresholds({});
    this.drivewealthStore.loadAccountSummariesV2({});
    this.drivewealthStore.loadAccountClaims({});
  }

  buttonText (account): string {
    if (account.liquidationStatus === DrivewealthAccountLiquidationStatus.Pending) {
      return "Liquidation In Progress";
    }
    else if (account.liquidationStatus === DrivewealthAccountLiquidationStatus.Completed) {
      return "Liquidation Complete";
    }
    else {
      return "Liquidate";
    }
  }

  get hsaInvestEnrollButtonDisabled (): boolean {
    return this.custodianSettingsStore.hsaInvestEnrollButtonDisabled;
  }

  get portalFunctionalityDisabled (): boolean {
    return this.custodianSettingsStore.portalFunctionalityDisabled;
  }

  get isLoaded (): boolean {
    return this.drivewealthStore.accountSummariesV2Loaded && this.enrollmentStore.feeScheduleLoaded;
  }

  get formattedDateNow (): string {
    return moment().format("MMM DD");
  }

  liquidationStatusDisplayCopy (liquidationStatus: DrivewealthAccountLiquidationStatus): string {
    switch (liquidationStatus) {
      case DrivewealthAccountLiquidationStatus.Completed:
        return "Completed";
      case DrivewealthAccountLiquidationStatus.Failed:
        return "Failed";
      case DrivewealthAccountLiquidationStatus.Pending:
        return "Pending";
      case DrivewealthAccountLiquidationStatus.NotStarted:
        return "Not Started";
      default:
        return "Not Started";
    }
  }

  get transferInKindPeriodElapsed (): boolean {
    const dateNow = moment();
    const endDate = moment.tz("2025-07-18 16:00", "America/New_York");
    return dateNow.isAfter(endDate);
  }

  get showAddAccountButton (): boolean {
    return this.featureFlagStore.flags.bend24350DisplayAddDWAccountButtonOnMultiAccountSelectView &&
        this.drivewealthStore.canOpenAnotherInvestmentAccount;
  }

  addInvestmentAccount (): void {
    this.$router.push(
        { name: RouteNames.DrivewealthWizard, params: { step: DrivewealthWizardStep.SelectAccountType } });
  }

  hasNonCompliantAccount (accountId: number): boolean {
    const migratedAccount = this.drivewealthStore.accountClaims.find(e => e.drivewealthApiAccountId === accountId);
    const accountSummary = this.drivewealthStore.accountSummaryById(accountId);

    return migratedAccount &&
      migratedAccount.isClaimed === false &&
      migratedAccount.isRepointedAccount === false &&
      !!accountSummary;
  }

  isAccountLiquidated (accountId: number): boolean {
    const accountSummary = this.drivewealthStore.accountSummaryById(accountId);

    return accountSummary.liquidationStatus === DrivewealthAccountLiquidationStatus.Completed;
  }

  displayNonCompliantDevenirSection (accountId: number): boolean {
    const hasNonCompliantAccount = this.hasNonCompliantAccount(accountId);

    return hasNonCompliantAccount && this.devenirNonCompliantUserMessageEnabled;
  }

  displayLiquidateMessage (accountId: number): boolean {
    const accountSummary = this.drivewealthStore.accountSummaryById(accountId);

    return accountSummary && accountSummary.equityValue > 0;
  }

  get devenirNonCompliantUserMessageEnabled (): boolean {
    return this.featureFlagStore.flags.bend22211DevenirNonCompliantUserMessageDisplay;
  }

  get advisoryAccount (): DrivewealthAccountSummary {
    const account = _.find(this.drivewealthStore.accountSummariesV2,
      x => x.accountManagementType === DrivewealthAccountManagementType.Advisory);

    return account;
  }

  get hasAdvisoryAccount (): boolean {
    return this.advisoryAccount !== undefined;
  }

  get displayAdvisoryNonCompliantSection (): boolean {
    if (!this.hasAdvisoryAccount) {
      return false;
    }

    return this.displayNonCompliantDevenirSection(this.advisoryAccount.drivewealthAccountId);
  }

  get openBrokerageAccount (): DrivewealthAccountSummary {
    const account = _.find(this.drivewealthStore.accountSummariesV2,
      x => x.accountManagementType === DrivewealthAccountManagementType.OpenBrokerage);

    return account;
  }

  get hasOpenBrokerageAccount (): boolean {
    return this.openBrokerageAccount !== undefined;
  }

  get displayOpenBrokerageNonCompliantSection (): boolean {
    if (!this.hasOpenBrokerageAccount) {
      return false;
    }

    return this.displayNonCompliantDevenirSection(this.openBrokerageAccount.drivewealthAccountId);
  }

  accountDisabledForEnrollment (accountSummary: DrivewealthAccountSummary): boolean {
    if (this.transferInKindPeriodElapsed) {
      return true;
    }

    return accountSummary.liquidationStatus !== null &&
      accountSummary.liquidationStatus === DrivewealthAccountLiquidationStatus.Pending ||
      accountSummary.liquidationStatus === DrivewealthAccountLiquidationStatus.Completed;
  }

  get managedAccount (): DrivewealthAccountSummary {
    const account = _.find(this.drivewealthStore.accountSummariesV2,
      x => x.accountManagementType === DrivewealthAccountManagementType.RiaManaged);

    return account;
  }

  get hasManagedAccount (): boolean {
    return this.managedAccount !== undefined;
  }

  get displayManagedNonCompliantSection (): boolean {
    if (!this.hasManagedAccount) {
      return false;
    }

    return this.displayNonCompliantDevenirSection(this.managedAccount.drivewealthAccountId);
  }

  get displayNonCompliantDevenirMessage (): boolean {
    return this.displayAdvisoryNonCompliantSection ||
      this.displayManagedNonCompliantSection ||
      this.displayOpenBrokerageNonCompliantSection;
  }

  get learnMoreLocation (): Location {
    return {
      name: RouteNames.DrivewealthLearnMorePages,
      params: {
        subpage: "list"
      }
    };
  }
}
